import { Box, Button, CircularProgress, Collapse, Grid, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { ClientsService } from "../../services/clients"
import { ISumulator } from "../../utils/@interfaces"
import moment from "moment"
import { Format } from "../../utils"
import { LineComponent } from "../../components/line"
import { IncrementValue } from "../../components/incrementValue"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { WarningModal } from "./modal/warning"
import { LoadingButton } from "@mui/lab"
import useAuth from "../../context/auth"
import { SelectPIXModal } from "./modal/pix"
import { ModalNotification } from "../../components/notification/modal"
import { ModalVideo, ModalVideoIphone } from "../../components/video/modal"
import { ModalLockCode } from "../dashboard/tabs/rent/components/modal/confirmLockCode"
import { ModalDayToPay } from "./modal/daysToPay"

export const Simulator = () => {
    const { user, getData, handleModal } = useAuth()
    const { state } = useLocation()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)
    const [loadingCreate, setLoadingCreate] = useState(false)

    const [openAgree, setOpenAgree] = useState(false)
    const [openPIX, setOpenPIX] = useState(false)

    const [pixType, setPixType] = useState<"cpf" | "cnpj">("cpf")

    const [data, setData] = useState<null | ISumulator>(null)
    const [value, setValue] = useState(0)

    const [openModalNotification, setOpenModalNotification] = useState(false)
    const [openModalVideo, setOpenModalVideo] = useState(false)
    const [openModalVideoIphone, setOpenModalVideoIphone] = useState(false)
    const [openModalPINCode, setOpenModalPINCode] = useState(false)
    const [openModalDayToPay, setOpenModalDayToPay] = useState(true)
    const [includeSaturday, setIncludeSaturday] = useState(true)

    const getSimulation = (value: number, excludeSaturday: boolean) => {
        setIncludeSaturday(!excludeSaturday)
        ClientsService.simulator(value, excludeSaturday)
            .then(({ data }) => setData(data))
            .finally(() => setLoading(false))
    }

    const createContract = () => {
        setOpenAgree(false)
        setLoadingCreate(true)
        ClientsService.createContract({
            value: state?.value as number,
            payTo: pixType,
            includeSaturday
        })
            .then(({ data }) => {
                if (data?.status === 1) {
                    navigate("/cliente/serasa")
                } else {
                    navigate("/cliente/pedido-reprovado")

                }
            })
            .finally(() => {
                getData()
                setLoadingCreate(false)
            })
    }

    const verifyPermission = () => {

        if (user?.client?.welcomeLocked && user?.client?.actualTable === 2) {
            setOpenModalPINCode(true)
            return
        }

        if (user?.client?.status === 10) {
            handleModal(true, {
                message: "Para solicitar um novo crédito, é necessário pagar todas as diárias do crédito atual",
                type: "warning",
                callback: () => {
                    navigate("/cliente")
                }
            })
            return
        }

        if ([1, 5, 10].includes(user?.actualContract?.contract?.status as number)) {
            handleModal(true, {
                message: "Você já tem uma solicitação sendo analisada.",
                type: "warning",
                callback: () => {
                    navigate("/cliente")
                }
            })
            return
        }

        const videoReads = localStorage.getItem('video-reads')
        if (Number(videoReads ?? 0) < 1) {
            setOpenModalVideo(true)
            return
        }

        if (!("Notification" in window)) {
            setOpenModalVideoIphone(true)
            return
        }

        if (Notification?.permission === "granted") {
            setOpenPIX(true)
        } else {
            setOpenModalNotification(true)
        }
    }

    useEffect(() => {
        if (state?.value) {
            setValue(state?.value)
        } else {
            toast("É preciso escolher o valor antes de simular", {
                type: "warning"
            })
            navigate("/cliente")
        }
    }, [])


    return (
        <>
            <Typography fontWeight={600} fontSize={"2rem"} p={0}>Detalhes das diárias</Typography>

            <Typography fontWeight={400} fontSize={"1.4rem"} p={0} mb={2} sx={{ opacity: 0.5 }}>Simulação para contrato assinado em {moment().format("DD/MM/YYYY[ (hoje)]")}</Typography>

            {/* <Typography fontWeight={600} fontSize={"1.4rem"} p={0}>Diárias</Typography> */}

            <Collapse in={!!data && !loading}>
                <Grid
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: ".3rem"
                    }}
                >
                    <Typography color="warning" fontSize={"1.4rem"} textAlign={"center"} mb={"1rem"}>O valor das diárias diminuem a cada dia <span style={{ fontSize: "2rem" }}>&#129295;</span></Typography>
                    <Box
                        key={"parcel-header"}
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            justifyContent: "space-between",
                            alignItems: "center",
                            boxSizing: "border-box",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            borderRadius: "10px",
                            minHeight: "3.7rem",
                            padding: ".3rem 1rem",
                        }}
                    >
                        <Typography fontSize={"1.6rem"} fontWeight={600}>Diárias</Typography>
                        <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5, ml: "-3rem" }} textAlign={"center"}>Vencimento</Typography>
                        <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">Valor</Typography>
                    </Box>
                    {data?.parcels?.map((parcel) => {
                        return (
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxSizing: "border-box",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    borderRadius: "10px",
                                    minHeight: "3.7rem",
                                    padding: ".3rem 1rem"
                                }}
                            >
                                <Typography fontSize={"1.6rem"} fontWeight={600}>{parcel.index} de 24</Typography>
                                <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5 }} textAlign={"center"}>Venc.: {moment(parcel.date).format("DD/MM/YY")}<br />{moment(parcel.date).format("[(]dddd[)]")}</Typography>
                                <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">{Format.currency(parcel.totalToPay)}</Typography>

                            </Box>
                        )
                    })}
                </Grid>
            </Collapse>
            {loading &&
                <Grid display={"flex"} alignItems={"center"} justifyContent={"center"}>
                    <CircularProgress />
                </Grid>
            }

            <LineComponent color="rgba(0, 0, 0, 0.2)" expansive height="0.5px" />

            <Grid
                display={"flex"}
                direction={"column"}
                flexWrap={"nowrap"}
                alignItems={"center"}
                gap={"1.5rem"}
            >
                <Typography fontWeight={400} fontSize={"1.8rem"}>Valor que irá receber</Typography>

                <Typography
                    fontWeight={800}
                    fontSize={"4rem"}
                    sx={{
                        background: "linear-gradient(90deg, #1D22E6 0%, #178BF1 100%)",
                        WebkitBackgroundClip: "text", // Recorte de fundo apenas no texto
                        WebkitTextFillColor: "transparent", // Torna o preenchimento do texto transparente,
                        mt: "-2rem"
                    }}
                >
                    <IncrementValue value={value} duration={2} />
                </Typography>

                <LoadingButton
                    onClick={verifyPermission}
                    variant="contained"
                    sx={{
                        background: "linear-gradient(90deg, #1D22E6 0%, #178BF1 100%)",
                        fontSize: "2rem",
                        fontWeight: "600",
                        width: "32.8rem",
                        padding: "4rem 2rem",
                        ... (!loadingCreate && {
                            animation: "pulse 2s infinite"
                        }),
                        "& .MuiCircularProgress-root": {
                            color: "white",
                        }
                    }}
                    disabled={loadingCreate}
                    loading={loadingCreate}
                >Solicite aqui seu crédito de {Format.currency(value)}</LoadingButton>

                <Button
                    onClick={() => navigate("/cliente")}
                    variant="outlined"
                    sx={{
                        fontWeight: "500",
                        width: "32.8rem",
                        height: "4.8rem",
                        borderColor: "#79747E"
                    }}
                    disabled={loadingCreate}
                >Cancelar</Button>

            </Grid>

            <WarningModal
                open={openAgree}
                onAgree={() => {
                    // if ([1, 4].includes(user?.client?.status as number) || user?.client?.needToTakePictures) {
                    navigate("/cliente/upload-documento", {
                        state: {
                            value,
                            payTo: pixType,
                            includeSaturday
                        }
                    })
                    // } else {
                    //         createContract()
                    // }
                }}
                onClose={() => setOpenAgree(false)}
            />

            <SelectPIXModal
                open={openPIX}
                value={value}
                onSelect={(value) => {
                    setOpenPIX(false)
                    setPixType(value)
                    setOpenAgree(true)
                }}
                onClose={() => setOpenPIX(false)}
            />

            <ModalNotification open={openModalNotification} onClose={() => setOpenModalNotification(false)} onConfirm={() => setOpenPIX(true)} />

            <ModalVideo open={openModalVideo} onClose={() => {
                const videoReads = localStorage.getItem('video-reads')
                if (videoReads) {
                    localStorage.setItem('video-reads', (Number(videoReads) + 1).toString())
                } else {
                    localStorage.setItem('video-reads', '1')
                }
                setOpenModalVideo(false)
            }} />

            <ModalVideoIphone open={openModalVideoIphone} onClose={() => {
                setOpenModalVideoIphone(false)
            }} />

            <ModalLockCode open={openModalPINCode} onClose={() => setOpenModalPINCode(false)} onConfirm={verifyPermission} />

            <ModalDayToPay open={openModalDayToPay} onConfirm={(excludeSaturday) => {
                getSimulation(value, excludeSaturday)
                setOpenModalDayToPay(false)
            }} />
        </>
    )
}